<template>
  <v-container tag="section">
    <base-material-card
      color="primary"
      icon="mdi-bank"
      inline
      class="px-5 py-4 ml-0"
      title="Governança - Responsáveis por Temas"
      elevation="0"
    >
      <v-row justify="space-between">
        <v-col cols="auto">
          <v-btn
            id="btn-cadastrar-responsavel"
            color="accent"
            dark
            class="mt-5"
            style="float:left"
            relative
            medium
            outlined
            @click="$router.push('responsaveis-temas/add-responsavel')"
          >
            <v-icon left size="30px">
              mdi-plus-circle
            </v-icon>
            Cadastrar Responsável
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="my-5">
        <v-col>
          <v-data-table
            :headers="headers"
            :items="itemsFiltered"
            :search="search"
            :loading="loading"
            disable-pagination
            hide-default-footer
            item-key="uniqueId"
          >
            <template v-slot:top>
              <v-row class="mx-auto" justify="space-between">
                <v-col cols="12" sm="auto">
                  <v-select
                    v-model="filtroBase"
                    :items="[
                      'TEC_AL',
                      'COMERCIAL',
                      'TEC_LD',
                      'TEC_SUB',
                      'SERVIÇOS',
                    ]"
                    label="Filtrar por Base"
                    clearable
                    hide-details
                  />
                </v-col>
                <v-col cols="12" sm="auto">
                  <select-company
                    ref="refSelectCompany"
                    :changeCompany="false"
                    :clearable="true"
                    @selected="filtroEmpresa = $event"
                  />
                </v-col>
                <v-col cols="12" sm="auto">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisa Geral"
                    single-line
                    clearable
                    hide-details
                  />
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.responsaveis="{ item }">
              <span v-if="item.responsaveis.length == 0">-</span>
              <v-chip
                v-for="responsavel in item.responsaveis"
                :key="responsavel.id"
                color="primary"
                outlined
                close
                class="mr-2"
                @click:close="deleteResponsavelTema(responsavel.id)"
              >
                {{ responsavel.user ? responsavel.user.name : "-" }}
              </v-chip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import GovernancaResponsaveisTemasService from "@/services/GovernancaResponsaveisTemasService";

  export default {
    name: "AdmGovernancaResponsaveisTemas",
    components: {
      SelectCompany: () => import("@/components/general/SelectCompany"),
    },
    data() {
      return {
        search: "",
        filtroBase: "",
        filtroEmpresa: "",
        headers: [
          { text: "Empresa", value: "empresa" },
          { text: "Base", value: "base" },
          { text: "Tema", value: "category" },
          { text: "Responsáveis", value: "responsaveis" },
        ],
        items: [],
        loading: false,
      };
    },
    computed: {
      itemsFiltered() {
        let items = this.items;

        if (this.filtroBase) {
          items = items.filter((item) => item.base === this.filtroBase);
        }
        if (this.filtroEmpresa) {
          items = items.filter(
            (item) => item.company_id === this.filtroEmpresa
          );
        }

        return items;
      },
    },
    created() {
      this.getItems();
    },
    methods: {
      getItems() {
        this.loading = true;

        GovernancaResponsaveisTemasService.index()
          .then((response) => {
            this.items = response;
          })
          .catch((error) => {
            console.error("Erro ao recuperar dados:", error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      deleteResponsavelTema(id) {
        GovernancaResponsaveisTemasService.deleteResponsavelTema(id)
          .then(() => {
            this.getItems();
            this.$toast.success("Responsável removido", "", {
              position: "topRight",
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error("Falha ao remover responsável", "", {
              position: "topRight",
            });
          });
      },
    },
  };
</script>

<style></style>
